import React, { useEffect, useRef, useState, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { TabPanel, TabView } from "primereact/tabview";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";

// ------------------ COMPONENTES DE BASE--------------------------

import Card from "../../../../Base/Components/Card/Card";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getDatesProduccion } from "../../../../Base/Services/Moment/Luxon";
import CalendarioOperativo from "../../../../Base/Components/Form/CalendarioOperativo";

// ------------------- CONSULTAS A LA API---------------------------

import { EliminarOrdenT, EliminarTarea, getOrdenesTrabajoDetalle, getOrdenesTrabajoEncabezado } from "../../../../API/Mantenimiento/OrdenesTrabajo/OrdenesTrabajoRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import OrdenesTrabajoCRUD from "./OrdenesTrabajoCRUD/OrdenesTrabajoCRUD";
import SubTareasCRUD from "./OrdenesTrabajoCRUD/SubTareasCRUD";


const OrdenesTrabajoScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selected, setSelected] = useState([]);
  const [encabezado, setEncabezado] = useState([]);
  const [detalles, setDetalles] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [habilitar, setHabilitar] = useState(true);
  const [ordenToShow, setOrdenToShow] = useState(null);
  const [modalAsignaciones, setModalAsignaciones] = useState(false);


  const getInfo = async () => {
    setLoading(true);
    setSelected([]);
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido.");
      return;
    }
    setLoading(true);
    const fechas = getDatesProduccion(dates);

    const encabezadoTempo = await getOrdenesTrabajoEncabezado(fechas);
    setEncabezado(encabezadoTempo);

    const detallesTempo = await getOrdenesTrabajoDetalle(fechas);
    setDetalles(detallesTempo);

    setLoading(false);
  };
  
  const showModal = () => {
    setShowDialog(true); 
  };
  
  const OrdenT = (Id) => {
    setOrdenToShow(Id);
    setShowDialog(true);
    showModal(); 
  };
  
  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ordenToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog(null);
          setOrdenToShow(null);
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog(null);
      setOrdenToShow(null);
      setHabilitar(true);
    }
  };

  const onConfirmEliminacion = () => {
    setShowConfirmDialog(false);
    eliminarIngreso();
  };

  const onHideConfirmDialog = () => {
    setShowConfirmDialog(false);
  };

  const confirmarEliminacion = () => {
    setShowConfirmDialog(true);
  };

  const eliminarIngreso = async () => {
    if (selected.length > 0) {
      try {
        const detallesCancelados = selected.every( (detalle) => detalle.IdEstado === 54);

        if (detallesCancelados) {
          toastShow( toast, "warn", "Advertencia", "La Orden de compra seleccionada ya esta eliminada.");
          return;
        }

        let response;
        if (activeIndex === 0) {
          response = await EliminarOrdenT(selected);
          if (response[0]?.ESTADO === 1) {
            toastShow(toast, "success", "Eliminado", response[0].MENSAJE);
            getInfo();
          } else {
            toastShow(toast, "error", "Error", response[0].MENSAJE);
          }
        } else {
          response = await EliminarTarea(selected.filter((detalle) => detalle.IdEstado !== 54));
          if (response[0]?.ESTADO === 1) {
            toastShow(toast, "success", "Eliminado", response[0].MENSAJE);
            getInfo();
          } else {
            toastShow(toast, "error", "Error", response[0].MENSAJE);
          }
        }
      } catch (error) {
        toastShow( toast, "error", "Error", "Error al eliminar la orden de trabajo.");
      }
    } else {
      toastShow( toast, "error", "No se puede eliminar", "Seleccione al menos un detalle de orden de trabajo.");
    }
  };

  const columnsOrdenes = [
    {
      field: "IdOrdenDeTrabajo",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      frozen: true,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setOrdenToShow(data);
      },
    },
      {
      field: "FechaCreado",
      header: "Fecha Creado",
      frozen: true,
      headerEn: "Date Create",
      className: "small",
    },
    {
      field: "NoOrdenTrabajo",
      header: "No. Orden",
      headerEn: "Maintenance Type",
      frozen: true,
      className: "small",
      Sumary: 'count',
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        OrdenT(data.NoOrdenTrabajo);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      frozen: true,
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      flex: 1,
      minWidth:250,
      className: "XXlarge",
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
    },
    {
      field: "Type",
      header: "Categoría",
      headerEn: "Category",
      className: "medium",
    },
    {
      field: "UserName",
      header: "Usuario Solicita",
      headerEn: "User Request",
      className: "XXlarge",
    },
    {
      field: "FechaFinalizada",
      header: "Fecha Finalización",
      headerEn: "Completion Date",
      className: "medium",
    },
  ];

  const tableOrdenes = {
    Columns: columnsOrdenes,
    Data: encabezado,
    loading: loading,
    selected: selected,
    setSelected: (e) => setSelected(e),
    showModal: (e) => showModal(e),
  };

  const columnsDetalles = [
    {
      field: "IdOrdenDeTrabajoDet",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "FechaCreado",
      header: "Fecha Creado",
      headerEn: "Date Create",
      frozen: true,
      className: "medium",
    },
    {
      field: "NoOrdenTrabajo",
      header: "No. Orden",
      headerEn: "No. Order",
      frozen: true,
      className: "small",
      Format: "Modal",
      Sumary: 'count',
      onCellDoubleClicked: ({ data }) => {
        OrdenT(data.NoOrdenTrabajo);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      frozen: true,
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn: "Description",
      className: "Xlarge",
    },
    {
      field: "CodigoActivo",
      header: "Codigo Activo",
      headerEn: "Active Code",
      className: "small",
    },
    {
      field: "NombreActivo",
      header: "Nombre Activo",
      headerEn: "Active Name",
      className: "XXlarge",
      flex:1,
      minWidth: 200,
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
    },
    {
      field: "TipoMantenimiento",
      header: "TipoMantenimiento",
      headerEn: "TipoMantenimiento",
      className: "medium",
    },

    {
      field: "TipoTrabajo",
      header: "TipoTrabajo",
      headerEn: "TipoTrabajo",
      className: "medium",
    },

    {
      field: "Priority",
      header: "Prioridad",
      headerEn: "Priority",
      className: "medium",
    }
  ];

  const tableDetalles = {
    Columns: columnsDetalles,
    Data: detalles,
    loading: loading,
    selected: selected,
    setSelected: (e) => setSelected(e),
    showModal: (e) => showModal(e),
  };
  
  useEffect(() => {
    setTitlePage(getLabel(baseLang, "ordenTrabajo", config.language));
    getInfo();
  }, []);


  return (
    <div>
      <Toast ref={toast} />
      <Dialog
        visible={showDialog}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <OrdenesTrabajoCRUD
          idOrden={ordenToShow}
          setOrdenToShow={setOrdenToShow}
          showDialog={showDialog}
          actualizarIngresosScreen={getInfo}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "ordenTrabajo", config.language)}</h2>
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button icon="pi pi-refresh" tooltip="Buscar" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={(e) => setShowDialog(true)}
            />
            <Button
              icon="pi pi-times"
              type="button"
              className="p-button-danger listado__botones"
                onClick={confirmarEliminacion}
              tooltip="Cancelar"
              tooltipOptions={{
                className: "purple-tooltip",
                position: "top",
              }}
              style={{ marginLeft: 1.5 }}
            />

            <ConfirmDialog
              visible={showConfirmDialog}
              onHide={onHideConfirmDialog}
              message="¿Estás seguro de que deseas eliminar?"
              header="Confirmación"
              icon="pi pi-exclamation-triangle"
              acceptLabel="Sí"
              rejectLabel="No"
              accept={onConfirmEliminacion}
              reject={onHideConfirmDialog}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Detalles">
                <div className="p-2" style={{ height: "83vh" }}>
                  <AgGrid table={tableDetalles} />
                </div>
              </TabPanel>
              <TabPanel header="Ordenes">
                <div className="p-2" style={{ height: "83vh" }}>
                  <AgGrid table={tableOrdenes} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      <Dialog
        visible={modalAsignaciones}
        onHide={() => {
          setModalAsignaciones(false)
        }}
        maximized={false}
        maximizable={true}
        closeOnEscape={false}
        header={"Sub Tareas"}
        style={{width: '61%', height: '70%'}}
      >
        <SubTareasCRUD
          detalleSeleccionado={selected}
          modalAsignaciones={modalAsignaciones}
          setModalAsignaciones={setModalAsignaciones}
        />
      </Dialog>
    </div>
  );
};

export default OrdenesTrabajoScreen;
